class KlaviyoBackInStockButton extends HTMLElement {
  onScriptLoad = () => {
    const klaviyo = window.klaviyo || [];

    const {
      listId,
      modalHeadline,
      modalBodyContent,
      modalEmailFieldLabel,
      modalButtonLabel,
      modalSubscriptionSuccessLabel,
      modalFooterContent,
      modalCloseLabel,
      modalBackgroundColor,
      modalTextColor,
      modalButtonTextColor,
      modalButtonBackgroundColor,
      modalCloseButtonColor,
      modalErrorBackgroundColor,
      modalErrorTextColor,
      modalSuccessBackgroundColor,
      modalSuccessTextColor,
      modalNewsletterSubscribeLabel,
      modalAdditionalStyles,
      modalFontFamily,
      modalHeadersFontFamily
    } = this.dataset;

    klaviyo.init({
      account: this.siteId,
      list: listId,
      platform: "shopify"
    });

    klaviyo.enable("backinstock", {
      modal: {
        headline: modalHeadline,
        body_content: modalBodyContent,
        email_field_label: modalEmailFieldLabel,
        button_label: modalButtonLabel,
        subscription_success_label: modalSubscriptionSuccessLabel,
        footer_content: modalFooterContent,
        close_label: modalCloseLabel,
        additional_styles: modalAdditionalStyles,
        background_color: modalBackgroundColor,
        text_color: modalTextColor,
        button_text_color: modalButtonTextColor,
        button_background_color: modalButtonBackgroundColor,
        close_button_color: modalCloseButtonColor,
        error_background_color: modalErrorBackgroundColor,
        error_text_color: modalErrorTextColor,
        success_background_color: modalSuccessBackgroundColor,
        success_text_color: modalSuccessTextColor,
        newsletter_subscribe_label: modalNewsletterSubscribeLabel,
        subscribe_checked: this.modalSubscribeChecked,
        font_family: modalFontFamily,
        headers_font_family: modalHeadersFontFamily
      }
    });

    this.button.disabled = false;
  };

  constructor() {
    super();

    const { siteId, modalSubscribeChecked } = this.dataset || {};

    if (siteId) {
      this.siteId = siteId;
      this.button = this.querySelector("button");
      this.modalSubscribeChecked = modalSubscribeChecked === "true";

      this.querySelector("script")?.addEventListener("load", this.onScriptLoad);
    }
  }
}

if (!window.customElements.get("klaviyo-back-in-stock-button")) {
  window.customElements.define(
    "klaviyo-back-in-stock-button",
    KlaviyoBackInStockButton
  );
}
